var _g, _path, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBagIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_273_41)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    width: 34,
    height: 34,
    rx: 10,
    fill: "#F8F0FF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.52 27.88H34.12C34.12 27.1162 33.8166 26.3836 33.2765 25.8435C32.7364 25.3034 32.0038 25 31.24 25C30.4762 25 29.7436 25.3034 29.2035 25.8435C28.6634 26.3836 28.36 27.1162 28.36 27.88H25.96C25.7054 27.88 25.4612 27.9811 25.2812 28.1612C25.1011 28.3412 25 28.5854 25 28.84V36.04C25 36.2946 25.1011 36.5388 25.2812 36.7188C25.4612 36.8989 25.7054 37 25.96 37H36.52C36.7746 37 37.0188 36.8989 37.1988 36.7188C37.3789 36.5388 37.48 36.2946 37.48 36.04V28.84C37.48 28.5854 37.3789 28.3412 37.1988 28.1612C37.0188 27.9811 36.7746 27.88 36.52 27.88ZM31.24 25.96C31.7492 25.96 32.2376 26.1623 32.5976 26.5224C32.9577 26.8824 33.16 27.3708 33.16 27.88H29.32C29.32 27.3708 29.5223 26.8824 29.8824 26.5224C30.2424 26.1623 30.7308 25.96 31.24 25.96ZM36.52 36.04H25.96V28.84H28.36V29.8C28.36 29.9273 28.4106 30.0494 28.5006 30.1394C28.5906 30.2294 28.7127 30.28 28.84 30.28C28.9673 30.28 29.0894 30.2294 29.1794 30.1394C29.2694 30.0494 29.32 29.9273 29.32 29.8V28.84H33.16V29.8C33.16 29.9273 33.2106 30.0494 33.3006 30.1394C33.3906 30.2294 33.5127 30.28 33.64 30.28C33.7673 30.28 33.8894 30.2294 33.9794 30.1394C34.0694 30.0494 34.12 29.9273 34.12 29.8V28.84H36.52V36.04Z",
    fill: "#5E05C6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_273_41",
    x: 0,
    y: 0,
    width: 62,
    height: 62,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.247059 0 0 0 0 0.278431 0 0 0 0 0.956863 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_273_41"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_273_41",
    result: "shape"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBagIcon);
export default __webpack_public_path__ + "static/media/bagIcon.bfcacc76fb5797081ec61da27d0fa41e.svg";
export { ForwardRef as ReactComponent };